import React, { useContext } from 'react';
import {
  Button,
  Card,
  CardTitle,
  CardBody,
  CardActions,
} from '@one-thd/sui-atomic-components';
import { CodeFullDetailDescription } from '../commons';
import { modalBlurbs } from '../../../../../constants/NationalAccount';
import { NationalAccountContext } from '../../../../../contexts';
import { stashLinkEvent } from '../../../../../utils/analytics';

export const AlreadyEnrolledSummary = (): JSX.Element => {
  const { setShowModal } = useContext<any>(NationalAccountContext);

  const unenrollBlurbs = modalBlurbs.unenroll;

  const AgreementDescription = (): JSX.Element => {
    return (
      <div
        data-testid="agreementDescription"
        className="sui-text-base lg:sui-text-lg sui-py-4 md:sui-py-0 md:sui-pr-4"
      >
        <div>
          <p data-testid="alignTextAndLink" className="sui-mb-4">
            {unenrollBlurbs.agreementDescription.line1}
          </p>
          <div className="sui-pt-2 sui-pb-10 md:sui-pb-4">
            {unenrollBlurbs.agreementDescription.line2}{' '}
            <a
              className="sui-inline-block sui-underline"
              onClick={() => {
                stashLinkEvent(
                  'pricing benefits: national account incentives: cards and accounts link',
                );
              }}
              href={unenrollBlurbs.cardsAndAccountsLink}
            >
              Cards & Accounts page
            </a>
            {'. '}
            {unenrollBlurbs.agreementDescription.line3}
          </div>
        </div>
        <div>
          <Button
            variant="text"
            onClick={() => {
              window.open(unenrollBlurbs.rebate);
              stashLinkEvent(
                'pricing benefits: national account incentives: terms and conditions link',
              );
            }}
            data-testid="tocButton"
          >
            <span className="sui-block">
              <span className="sui-inline-block sui-pr-1">
                {unenrollBlurbs.termsAndConditions[0]}
              </span>
              <span className="sui-inline-block">
                {unenrollBlurbs.termsAndConditions[1]}
              </span>
            </span>
          </Button>
        </div>
      </div>
    );
  };

  const AgreementSummary = (): JSX.Element => {
    return (
      <Card data-testid="agreementBox" CardContentProps={{ grow: true }}>
        <CardTitle header="Agreement Details" headerWeight="bold" />
        <CardBody>
          <CodeFullDetailDescription />
        </CardBody>
        <CardActions>
          <Button variant="text" onClick={() => setShowModal(true)}>
            {unenrollBlurbs.buttons.unenroll}
          </Button>
        </CardActions>
      </Card>
    );
  };

  return (
    <div
      data-testid="alreadyEnrolledSummary"
      className="sui-pt-5 sui-flex sui-flex-col sui-flex-col-reverse sui-gap-4 md:sui-grid md:sui-grid-cols-2"
    >
      <AgreementDescription />
      <AgreementSummary />
    </div>
  );
};
